import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { UNKNOWN_COMPONENT } from '../constants';
import { useErrorMonitor } from './useErrorMonitor';
export const withErrorMonitor = (WrappedComponent) => {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    const Wrapped = (props) => {
        const errorMonitor = useErrorMonitor();
        return React.createElement(WrappedComponent, { ...{ ...props, errorMonitor } });
    };
    Wrapped.displayName = `withErrorMonitor(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    hoistNonReactStatics(Wrapped, WrappedComponent);
    return Wrapped;
};
//# sourceMappingURL=withErrorMonitor.js.map